import { SxStyleProp } from "theme-ui"

export const root: SxStyleProp = {
  whiteSpace: "nowrap",
  mb: [1],
}
